@if ((assortments$ | async).length > 0) {
<h6 i18n="userMenu@@currentlyActiveAssortments">
  Currently active assortments:
</h6>
} @else {
<h6 i18n="userMenu@@noActiveAssortments">There are no assortments active</h6>
}

<ul class="mb-3">
  @for (assortmentCode of assortments$ | async; track assortmentCode; let index
  = $index) {
  <li>
    {{ assortmentCode }}
    <fa-icon
      class="delete-button"
      [icon]="['fas', 'xmark']"
      (click)="onDelete(index)"
      data-e2e="assortment-code-delete-icon"
    ></fa-icon>
  </li>
  }
</ul>

<form [formGroup]="assortmentForm" (ngSubmit)="onSubmit()">
  <input
    class="form-control"
    type="text"
    inputmode="numeric"
    [formControl]="assortmentCodeControl"
    data-e2e="assortment-code-input"
    [class.is-invalid]="
      assortmentCodeControl.invalid &&
      assortmentCodeControl.dirty &&
      assortmentCodeControl.value !== ''
    "
    [disabled]="isUpdateInProgress$ | async"
  />
  @if (assortmentCodeControl.getError(ALREADY_EXISTS_ERROR)) {
  <div
    class="invalid-feedback"
    i18n="userMenu@@assortmentCodeAlreadyEnteredError"
  >
    You have already entered this code
  </div>
  }

  <button
    type="submit"
    class="btn btn-block btn-primary mt-3"
    data-e2e="submit-assortment"
    i18n="userMenu@@submitNewAssortmentCode"
    (click)="onSubmit()"
    [disabled]="assortmentForm.invalid || (isUpdateInProgress$ | async)"
  >
    @if (isUpdateInProgress$ | async) {
    <fa-icon
      [icon]="['fas', 'spinner']"
      [spin]="true"
      [pulse]="true"
      class="mr-1"
    ></fa-icon>
    } Submit
  </button>
</form>
